import React, { useEffect } from 'react'
import { SessionRegion, useSessionContext } from '../../session'
import { ProtectedPage } from '../protected/protected-page'
export interface InternationalPageProps {
  page: React.ReactElement
}

export const InternationalPage: React.FC<InternationalPageProps> = ({ page }) => {
  const { sessionData } = useSessionContext()
  useEffect(() => {
    if (sessionData.region !== SessionRegion.INTL) {
      window.location.href = '/us/search'
    }
  }, [sessionData.region])

  return <ProtectedPage page={page} />
}
